import { render, staticRenderFns } from "./RegisterFormWrapper.vue?vue&type=template&id=03055d0c&scoped=true&"
import script from "./RegisterFormWrapper.vue?vue&type=script&lang=js&"
export * from "./RegisterFormWrapper.vue?vue&type=script&lang=js&"
import style0 from "./RegisterFormWrapper.vue?vue&type=style&index=0&id=03055d0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03055d0c",
  null
  
)

export default component.exports